module.exports = __webpack_public_path__ + "static/media/gravata.5a852b86.jpeg";